const React = require('react');

const IconPlayStore = () => (
  <svg
    width="62"
    height="20"
    viewBox="0 0 62 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="62" height="20" rx="2" fill="#333333" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9692 9.18194V9.86947H24.7352C24.7075 10.1933 24.5634 10.4989 24.3264 10.7365C23.9691 11.0765 23.4747 11.2597 22.9651 11.2407C21.8813 11.2407 21.0028 10.4199 21.0028 9.4073C21.0028 8.39474 21.8813 7.5739 22.9651 7.5739C23.4629 7.56631 23.9437 7.74351 24.3019 8.06662L24.8211 7.58154C24.3325 7.11931 23.6644 6.86164 22.9692 6.86727C21.9794 6.83129 21.0479 7.30411 20.5416 8.09949C20.0353 8.89488 20.0353 9.88534 20.5416 10.6807C21.0479 11.4761 21.9794 11.9489 22.9692 11.9129C23.6771 11.9428 24.3643 11.6852 24.8538 11.2063C25.2821 10.7667 25.5107 10.1887 25.4915 9.59446C25.4928 9.44969 25.4791 9.30514 25.4506 9.16284L22.9692 9.18194ZM27.5028 8.68157C26.5438 8.68368 25.768 9.41141 25.7695 10.3075C25.771 11.2035 26.5492 11.929 27.5083 11.9283C28.4673 11.9276 29.2443 11.201 29.2443 10.3049C29.2511 9.87116 29.069 9.45341 28.74 9.14738C28.4109 8.84135 27.9629 8.67324 27.4987 8.68157H27.5028ZM29.5795 10.31C29.5765 9.41445 30.3503 8.68578 31.3088 8.68157C31.773 8.67324 32.2209 8.84135 32.55 9.14738C32.8791 9.45342 33.0611 9.87116 33.0544 10.3049C33.0544 11.2005 32.2782 11.9269 31.3197 11.9283C30.3612 11.9297 29.5825 11.2056 29.5795 10.31ZM30.2835 10.7321C30.4702 11.0972 30.8768 11.3186 31.3088 11.2904C31.58 11.2845 31.8371 11.1765 32.0218 10.991C32.2065 10.8054 32.3032 10.558 32.2899 10.3049C32.2889 9.90025 32.0232 9.53734 31.62 9.38973C31.2168 9.24212 30.7579 9.33981 30.463 9.63608C30.168 9.93235 30.0968 10.367 30.2835 10.7321ZM26.4748 10.7351C26.6628 11.0999 27.0705 11.3202 27.5028 11.2904H27.4987C27.7698 11.2845 28.027 11.1766 28.2117 10.991C28.3964 10.8055 28.4931 10.558 28.4798 10.3049C28.4786 9.89996 28.2124 9.53689 27.8087 9.38961C27.405 9.24232 26.9459 9.34081 26.6514 9.63789C26.3568 9.93497 26.2868 10.3702 26.4748 10.7351ZM40.004 8.68152C40.6818 8.70484 41.2738 9.11666 41.4921 9.71665L41.5779 9.88854L39.2518 10.7862C39.3976 11.0964 39.7316 11.2918 40.094 11.2789C40.4439 11.2797 40.7684 11.1085 40.9484 10.8282L41.5411 11.2101C41.2185 11.6614 40.6748 11.9312 40.094 11.9282C39.6322 11.9346 39.1876 11.7652 38.8623 11.459C38.5369 11.1529 38.3588 10.7362 38.3688 10.3049C38.3406 9.88339 38.5003 9.46977 38.8101 9.16224C39.1198 8.85471 39.552 8.6807 40.004 8.68152ZM39.1211 10.2592C39.1043 10.0205 39.1911 9.78553 39.3618 9.60731C39.5326 9.42908 39.7729 9.32258 40.0286 9.3118C40.2981 9.2952 40.5523 9.43048 40.6745 9.6556L39.1211 10.2592ZM37.9968 11.8331H37.2324V7.05853H37.9968V11.8331ZM35.9814 9.0445H35.9528C35.7198 8.80107 35.3866 8.66211 35.0371 8.66254C34.1092 8.70458 33.3799 9.41976 33.3799 10.2878C33.3799 11.1558 34.1092 11.871 35.0371 11.913C35.3878 11.9185 35.7231 11.7787 35.9528 11.531H35.9773V11.764C35.9773 12.3866 35.6217 12.7189 35.0494 12.7189C34.6595 12.7104 34.3138 12.4825 34.1745 12.1422L33.5082 12.4019C33.7648 12.9851 34.3745 13.3644 35.0494 13.3606C35.9446 13.3606 36.6846 12.8679 36.6846 11.6686V8.77713H35.9814V9.0445ZM35.1053 11.2902L35.1066 11.2903H35.1025L35.1053 11.2902ZM35.7942 10.9839C35.6187 11.1694 35.37 11.28 35.1053 11.2902C34.5593 11.2447 34.1407 10.8172 34.1407 10.3049C34.1407 9.79221 34.56 9.36447 35.1066 9.31946C35.3707 9.33212 35.6182 9.44389 35.7929 9.62941C35.9676 9.81494 36.0548 10.0585 36.0346 10.3049C36.0571 10.5524 35.9703 10.7978 35.7942 10.9839ZM45.0732 7.05852H43.2458V11.833H44.0103V10.0225H45.0773C45.6712 10.0624 46.2391 9.78896 46.549 9.31398C46.859 8.839 46.859 8.24204 46.549 7.76706C46.2391 7.29209 45.6712 7.01866 45.0773 7.05852H45.0732ZM44.0062 9.35005H45.0732L45.0896 9.36151C45.5739 9.36151 45.9665 8.9947 45.9665 8.54221C45.9665 8.08972 45.5739 7.7229 45.0896 7.7229H44.0062V9.35005ZM49.7868 8.66249C49.218 8.63073 48.6833 8.91729 48.4255 9.39202L49.1041 9.65557C49.2408 9.42016 49.5133 9.28235 49.799 9.30417C49.9951 9.28278 50.1921 9.33586 50.3458 9.4515C50.4996 9.56713 50.5971 9.73562 50.6166 9.91912V9.96877C50.3711 9.84731 50.0973 9.78434 49.8195 9.78544C49.0877 9.78544 48.3478 10.1674 48.3478 10.8587C48.3624 11.1565 48.5053 11.4362 48.744 11.634C48.9827 11.8319 49.2969 11.9311 49.6151 11.9091C50.0072 11.9354 50.3834 11.7597 50.5962 11.4508H50.6207V11.8327H51.3566V9.99551C51.3566 9.15903 50.678 8.67395 49.8072 8.67395L49.7868 8.66249ZM49.0959 10.874C49.0959 11.1605 49.4434 11.2789 49.6927 11.2789L49.7132 11.2903C50.1737 11.2799 50.5556 10.954 50.6085 10.5265C50.3963 10.4158 50.1563 10.3604 49.9135 10.366C49.5292 10.366 49.0959 10.4921 49.0959 10.874ZM54.0384 8.77704L53.1635 10.8473H53.139L52.2314 8.77704H51.4138L52.7751 11.6723L51.9984 13.2804H52.7956L54.8887 8.77704H54.0384ZM47.9308 11.8331H47.1663V7.05853H47.9308V11.8331Z"
      fill="white"
    />
    <path
      d="M6.72076 5.12256C6.58752 5.27195 6.52027 5.46319 6.53271 5.65731V14.1063C6.52027 14.3004 6.58752 14.4917 6.72076 14.641L6.74938 14.6678L11.8145 9.9391V9.82833L6.74938 5.09583L6.72076 5.12256Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M13.4905 11.5166L11.8145 9.9391V9.82833L13.4905 8.24701L13.5273 8.26611L15.5346 9.33178C16.1069 9.63353 16.1069 10.1301 15.5346 10.4356L13.5355 11.4975L13.4905 11.5166Z"
      fill="url(#paint1_linear)"
    />
    <path
      d="M13.5396 11.4937L11.8145 9.88184L6.72076 14.641C6.96143 14.8387 7.31861 14.8483 7.57108 14.6639L13.5437 11.4937"
      fill="url(#paint2_linear)"
    />
    <path
      d="M13.5396 8.26995L7.56693 5.09966C7.31447 4.91528 6.95729 4.92491 6.71661 5.12258L11.8144 9.88184L13.5396 8.26995Z"
      fill="url(#paint3_linear)"
    />
    <path
      opacity="0.2"
      d="M13.4906 11.4594L7.56699 14.6105C7.32458 14.7798 6.99179 14.7798 6.74938 14.6105L6.72076 14.6372L6.74938 14.664C6.99133 14.8346 7.32504 14.8346 7.56699 14.664L13.5396 11.4937L13.4906 11.4594Z"
      fill="black"
    />
    <path
      opacity="0.12"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4906 11.4593L15.5346 10.3784C15.7458 10.281 15.8968 10.0976 15.9434 9.88184C15.9223 10.1203 15.7664 10.3301 15.5346 10.4318L13.5274 11.4937L13.4906 11.4593ZM6.53183 14.1272C6.53858 14.2953 6.60459 14.4573 6.72077 14.5876L6.74939 14.6182L6.72077 14.6449C6.59143 14.4999 6.52427 14.3154 6.53183 14.1272ZM6.53183 14.1272C6.53205 14.1215 6.53235 14.1158 6.53271 14.1102V14.0529C6.53112 14.0777 6.53083 14.1025 6.53183 14.1272Z"
      fill="black"
    />
    <path
      opacity="0.25"
      d="M7.56693 5.15374L15.5346 9.38584C15.7458 9.48325 15.8968 9.66664 15.9434 9.88239C15.9223 9.64389 15.7664 9.43411 15.5346 9.33237L7.56693 5.10027C6.9946 4.79852 6.52856 5.05061 6.52856 5.66175V5.71904C6.54083 5.10409 6.99869 4.852 7.56693 5.15374Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="9.59597"
        y1="-0.644667"
        x2="1.56275"
        y2="1.64192"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.01" stopColor="#00A1FF" />
        <stop offset="0.26" stopColor="#00BEFF" />
        <stop offset="0.51" stopColor="#00D2FF" />
        <stop offset="0.76" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="16.2827"
        y1="5.98568"
        x2="6.39372"
        y2="5.98568"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.41" stopColor="#FFBD00" />
        <stop offset="0.78" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="6.5711"
        y1="7.40963"
        x2="0.688652"
        y2="17.9999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="2.74301"
        y1="3.8071"
        x2="5.36864"
        y2="8.53613"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.07" stopColor="#2DA771" />
        <stop offset="0.48" stopColor="#15CF74" />
        <stop offset="0.8" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
);

module.exports = React.memo(IconPlayStore);
